function handleKpLogin() {
    const token = getValueFromCookiesOrLocalStorage(XGokwikCoreToken(window.merchantInfo.environment));
    const customerId = getCustomerId();
    if (token && customerId != null) {
      window.location.href = '/account';
    } else {
      handleKpAndShopifyLogin('/account');
    }
  }

  function autoLogin() {
    document.getElementById('kwik-pass-text').textContent = "{{'customer.account_fallback' | t}}";
  }

  window.addEventListener('user-loggedin', function (event) {
    const { token } = event?.detail;
    if (token) {
      autoLogin();
    }
  });

  document.addEventListener('DOMContentLoaded', function () {
    var userToken = localStorage.getItem('KWIKSESSIONTOKEN');
    if (userToken) {
      autoLogin();
    }
  });